/**
 * HelpDrawerFooter — pied fixe du Help Drawer (extrait pour tenir < 300 lignes).
 * Bouton « Centre d'aide » contextuel + indice clavier (composant `Kbd`).
 */

import { useTranslation } from 'react-i18next'
import { BookOpen } from 'lucide-react'

import { Button } from '../ui/button'
import { Kbd } from '../ui/kbd'

export function HelpDrawerFooter({
    isReadingArticle,
    onOpenDocCenter,
}: {
    isReadingArticle: boolean
    onOpenDocCenter: () => void
}) {
    const { t } = useTranslation()
    return (
        <div className="space-y-2 border-t border-border bg-muted/30 px-4 py-3">
            <Button
                variant="outline"
                className="h-11 w-full gap-2 rounded-xl border-0 bg-card font-medium shadow-md transition-shadow hover:shadow-lg motion-reduce:transition-none"
                onClick={onOpenDocCenter}
            >
                <BookOpen className="h-4 w-4" />
                {isReadingArticle ? t('help.readInPortal') : t('help.goToKnowledgePortal')}
            </Button>
            <p className="text-center text-[11px] text-muted-foreground/80">
                {t('help.keyboardHint')} <Kbd>⌘/</Kbd>
            </p>
        </div>
    )
}
